import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { ReportStatusEnum } from "domain/reports/enums"

type TInitState = {
  reports: Record<string, ReportStatusEnum>
}

const initState: TInitState = {
  reports: {},
}

export const ReportsContext = createContext(initState)
export const ReportsProvider = createProvider<TInitState>(
  ReportsContext,
  initState
)
